import request from '@/utils/request'

export function meetStoryList(data) {
    return request({
        url: '/backend/story/meetStoryList',
        method: 'post',
        data: data
    })
}

export function allMeetStoryList(data) {
    return request({
        url: '/backend/story/allMeetStoryList',
        method: 'post',
        data: data
    })
}

export function createUpdateMeetStory(data) {
    return request({
        url: '/backend/story/createUpdateMeetStory',
        method: 'post',
        data: data
    })
}
export function getMeetStoryInfo(data) {
    return request({
        url: '/backend/story/getMeetStoryInfo',
        method: 'post',
        data: data
    })
}
export function deleteMeetStory(data) {
    return request({
        url: '/backend/story/deleteMeetStory',
        method: 'post',
        data: data
    })
}
export function updateMeetStoryStatus(data) {
    return request({
        url: '/backend/story/updateMeetStoryStatus',
        method: 'post',
        data: data
    })
}
export function updateMeetStorySort(data) {
    return request({
        url: '/backend/story/updateMeetStorySort',
        method: 'post',
        data: data
    })
}


export function studentStoryList(data) {
    return request({
        url: '/backend/story/studentStoryList',
        method: 'post',
        data: data
    })
}
export function createUpdateStudentStory(data) {
    return request({
        url: '/backend/story/createUpdateStudentStory',
        method: 'post',
        data: data
    })
}
export function getStudentStoryInfo(data) {
    return request({
        url: '/backend/story/getStudentStoryInfo',
        method: 'post',
        data: data
    })
}
export function deleteStudentStory(data) {
    return request({
        url: '/backend/story/deleteStudentStory',
        method: 'post',
        data: data
    })
}
export function updateStudentStoryStatus(data) {
    return request({
        url: '/backend/story/updateStudentStoryStatus',
        method: 'post',
        data: data
    })
}
export function updateStudentStorySort(data) {
    return request({
        url: '/backend/story/updateStudentStorySort',
        method: 'post',
        data: data
    })
}

export function createUpdateMeetStoryVideo(data) {
    return request({
        url: '/backend/story/createUpdateMeetStoryVideo',
        method: 'post',
        data: data
    })
}

export function getAllMeetStoryCategory(data) {
    return request({
        url: '/backend/story/getAllMeetStoryCategory',
        method: 'post',
        data: data
    })
}

export function updateMeetStoryRecommend(data) {
    return request({
        url: '/backend/story/updateMeetStoryRecommend',
        method: 'post',
        data: data
    })
}